<script setup lang="ts">
const route = useRoute()

const { data } = await useAsyncData(`tracking-${route.path}`, () =>
  queryCollection('tracking').path(route.path).first()
)

if (route.params.slug && !data.value) {
  const order_id =
    typeof route.params.slug === 'string'
      ? route.params.slug
      : route.params.slug.join('|')

  await navigateTo({
    path: '/tracking',
    query: {
      order_id
    }
  })
}

const courier = computed(() =>
  getCourierProps(route.params.slug?.toString() || '')
)

useDefaultMeta({
  title: data.value?.meta?.title ?? data.value?.title,
  description: data.value?.meta?.description ?? data.value?.description,

  robots: 'index, follow',
  schema: {
    type: ['SoftwareApplication', 'WebApplication'],
    breadcrumbs: [
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Cek Resi',
        item: appUrl('/tracking')
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: courier.value?.courier || 'Tracking',
        item: appUrl(route.fullPath)
      }
    ]
  }
})
</script>

<template>
  <TrackingHero
    :courier="courier"
    :title="data?.meta?.title ?? data?.title"
    :description="data?.meta?.description ?? data?.description"
  />
  <PresetBenefit
    v-if="data?.benefit"
    :benefit-title="data?.benefit.title"
    :benefits="data?.benefit.items ?? []"
  />
  <UiSectionWrapper
    image-class="order-first lg:order-first"
    hero-image="/images/dashboard-member-banner-1.webp"
    :title="data?.business_cta?.title"
    :items="data?.business_cta?.items ?? []"
    :button-label="data?.business_cta?.label"
    class="py-12"
  />
  <PresetCourier path="/tracking" />
  <FaqBase
    v-if="data?.faq"
    :title="data?.faq.title"
    :faqs="data?.faq.items ?? []"
  />
  <CtaSection />
</template>
